import { useQuery } from "@tanstack/react-query";
import AddonsService from "../services/AddonsService";
import { TeamRole } from "../constants";
import { AddonCatalogItemDto } from "@growth-machine-llc/stridist-api-client";
import { useCurrentUser } from "./useCurrentUser";
import { ADDON_CATALOG } from "../constants/addons";

export const ADDONS_QUERY_KEY = "addons";
export const ADDONS_CATALOG_QUERY_KEY = "addons-catalog";

const addonsIndexMap = Object.keys(ADDON_CATALOG).reduce((acc, key, index) => {
  acc[key] = index;
  return acc;
}, {});

const getAddonOrder = (addons: AddonCatalogItemDto[]) => {
  return addons.sort((a, b) => {
    const aIndex = addonsIndexMap[a.code] || 0;
    const bIndex = addonsIndexMap[b.code] || 0;
    return aIndex - bIndex;
  });
};

export function useAddons() {
  const { teamRole } = useCurrentUser();
  return useQuery({
    queryKey: [ADDONS_QUERY_KEY],
    queryFn: AddonsService.getUserActiveAddons,
    enabled: teamRole === TeamRole.OWNER,
  });
}

export function useAddonsCatalog() {
  return useQuery({
    queryKey: [ADDONS_CATALOG_QUERY_KEY],
    queryFn: AddonsService.getAddonsCatalog,
    select: (data) => {
      // return in order of ADDON_CATALOG
      return {
        MONTH: getAddonOrder(data.MONTH),
        YEAR: getAddonOrder(data.YEAR),
      };
    },
  });
}
